import React from 'react';
import { RocketIcon, ZapIcon, CheckIcon } from 'lucide-react';
export function CTASection() {
  return <section className="py-16 md:py-24 bg-orange-700 text-white" data-id="element-57">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58">
        <div className="text-center mb-10 sm:mb-12" data-id="element-59">
          <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-orange-100 rounded-full mb-6" data-id="element-60">
            <RocketIcon className="h-8 w-8 sm:h-10 sm:w-10 text-orange-700" data-id="element-61" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight px-2" data-id="element-62">
            Crea tu Negocio Digital Automatizado con IA
          </h2>
          <p className="text-lg sm:text-xl md:text-2xl text-orange-100 max-w-3xl mx-auto px-4 mb-8" data-id="element-63">
            Bootcamp de 4 semanas para crear tu sistema de ventas automatizado
          </p>
        </div>
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-2xl overflow-hidden mb-10" data-id="element-64">
          
          
        </div>
        <div className="text-center" data-id="element-65">
          <p className="text-orange-200 italic text-lg" data-id="element-66">
            "La IA no reemplazará a las personas, pero las personas que usan IA
            reemplazarán a las que no."
          </p>
        </div>
      </div>
    </section>;
}
const features = ['4 semanas de formación intensiva con clases en vivo', 'Plantillas de landing page y VSL optimizadas para conversión', 'Prompts de IA para crear contenido persuasivo en minutos', 'Sistema de seguimiento y análisis de métricas', 'Comunidad privada y soporte personalizado', 'Bonus: 10 plantillas de emails automatizados', 'Bonus: Guía de anuncios que convierten con IA'];
const nextCohortDate = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toLocaleDateString('es-ES', {
  day: 'numeric',
  month: 'long',
  year: 'numeric'
});